module.exports = __webpack_public_path__ + "assets/img/shu_05.2c0146bc.png";